import styled from 'styled-components';

export const EmergencyHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainTitle = styled.div`
  font: normal normal 600 22px / 26px Biotif;
  margin: 17px;
  padding-top: 15px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}
`;

export const BelowTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin: 17px;
  padding-top: 5px;
  padding-left: 10px;
  display: flex;
}
`;

export const InputIcon = styled.img`
  height: auto;
`;

export const ExpandIcon = styled(InputIcon)<{ isOpen: boolean }>`
  width: 22px;
  cursor: pointer;
  margin-right: 10px;
  transition: transform 0.5s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  position: relative;
  top: -2px;
`;

export const Collapsible = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: auto;
  width: auto;
  flex-wrap: wrap;
`;

export const FormTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const EditIcon = styled.img`
  width: 15px;
  margin-left: 2rem;
`;

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0.8em 0.8em 0.8em 0;
`;

export const DependentFormContainer = styled.div`
  display: flex;
  flex-direction: column;

  flex-wrap: wrap;
  background: white;
  padding: 1em;
`;

export const FormInputContainer = styled.div`
  margin: 0.5em;
`;

export const EmptyEmergencyContainer = styled.div`
  display: flex;
  background: white;
  padding: 1em;
  border-radius: 0px 4px 4px 4px;
  font: normal normal normal 20px/30px Biotif;
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;
